import {assert} from 'Asserts';
import {DataFrameColumns} from 'data-frames/DataFrameTypes';
import {isColumnTypeNumerical} from 'data-frames/DataFrameTypes';
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepConfig} from 'pipelines/PipelineTypes';

import {ChartOptionType} from './ChartingTypes';

export function getDefaultChartConfig(
  chartOptionType: ChartOptionType,
  dataFrameColumns: DataFrameColumns
): PipelineStepConfig<PipelineStepType.CHART_VIEW, 0> {
  assert(
    chartOptionType === ChartOptionType.BOXPLOT,
    'Only boxplot can be created without a visualization parameter object'
  );
  const firstTextColumnIndex = dataFrameColumns.findIndex((column) => column.type.leafType === LeafType.TEXT);
  const firstNumberColumnIndex = dataFrameColumns.findIndex((column) => isColumnTypeNumerical(column.type));
  const xAxisColumnName =
    firstTextColumnIndex !== -1
      ? dataFrameColumns[firstTextColumnIndex].systemName
      : dataFrameColumns[0].systemName;
  const yAxisColumnName =
    firstNumberColumnIndex !== -1
      ? dataFrameColumns[firstNumberColumnIndex].systemName
      : dataFrameColumns[0].systemName;
  return {
    chartConfig: {
      type: 'BOX_PLOT' as const,
      parameters: {
        xAxisColumnName,
        yAxisColumnName,
        showPoints: 'ALL',
        showLegend: true,
        xAxisLabel: null,
        xAxisMin: null,
        xAxisMax: null,
        sortDirection: 'ASCENDING',
        legendLocation: 'RIGHT',
        pointLabelColumnName: null,
        yAxisLabel: null,
        yAxisMin: null,
        yAxisMax: null,
        invertYAxis: false,
        seriesColumnName: null,
        legendLabel: null,
        markerShape: null,
        markerShapeOpen: null,
        markerOpacity: null,
      },
    },
    chartName: 'Box plot',
  };
}
